/* Casca de cada painel. Substitui o AppShell do projeto de origem (decisão D7).

   O AppShell trazia sidebar, header, toggle de tema, troca de perfil e um
   índice de seções com scroll spy. Nada disso vem para o AVA: a plataforma já
   tem sidebar e header, não tem tema escuro, e o perfil vem do papel do
   usuário.

   Sem card externo, e sem título
   ------------------------------
   A primeira versão embrulhava tudo num CCard com título ("Painel do
   Professor") e legenda de escopo. Isso criava uma moldura dentro da moldura —
   o conteúdo portado já é feito de cards — e o título repetia o que o
   breadcrumb e o menu lateral já dizem.

   Agora a barra superior é só **breadcrumb + toolbar**, e o breadcrumb é o
   localizador: ele mostra em que nível da hierarquia o usuário está (rede ›
   região › escola › turma) com as tags coloridas de cada nível. O conteúdo
   respira direto na página, com seus próprios cards e divisões.

   Quando não há trilha (nível raiz), cai para um rótulo simples de escopo, para
   a barra não ficar órfã. */

import React from "react";

import PropTypes from "prop-types";

export default function PainelShell({
  escopoLabel,
  escopoValor,
  breadcrumb,
  toolbar,
  children
}) {
  const temCabecalho = breadcrumb || escopoValor || toolbar;

  return (
    <div className="ie-root">
      {temCabecalho && (
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-0 flex-1">
            {breadcrumb || (
              <span className="flex items-center gap-1.5 text-[13px]">
                {escopoLabel && (
                  <span className="rounded-md bg-[var(--color-brand-dim)] px-1.5 py-[1px] text-[9.5px] font-bold uppercase tracking-wide text-[var(--color-brand)]">
                    {escopoLabel}
                  </span>
                )}
                <span className="truncate font-semibold text-[var(--color-ink)]">
                  {escopoValor}
                </span>
              </span>
            )}
          </div>
          {toolbar && <div className="flex-none">{toolbar}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

PainelShell.propTypes = {
  escopoLabel: PropTypes.string,
  escopoValor: PropTypes.string,
  breadcrumb: PropTypes.node,
  toolbar: PropTypes.node,
  children: PropTypes.node
};

PainelShell.defaultProps = {
  escopoLabel: null,
  escopoValor: null,
  breadcrumb: null,
  toolbar: null,
  children: null
};
